import React, { useState } from 'react';

import PropTypes from 'prop-types';

import styled from 'styled-components';

import { COUNTRY_CODE_CLICKED } from 'constants/amplitude/AmplitudeEvents';
import { FLOW, PHONE_COUNTRY } from 'constants/amplitude/AmplitudeParamName';
import { LOGIN_REGISTRATION_FORM_NAME } from 'constants/formName';

import amplitude from 'amplitude-js';

import NewInputPhone from './NewInputPhone';
import ChangeCountryCodePopup from '../auth/profile/ChangeCountryCodePopup';
import { FlagIcon } from '../common/FlagIcon/FlagIcon';
import { Icon } from '../common/Icon/Icon';

const FlagIconDropdown = styled.div`
    display: flex;
    padding-right: 8px;
    margin-right: 16px;
    border-right: 1px solid ${(props) => props.theme.grey_28_tr};
    cursor: ${(props) => (props.isNonEditableCountry && !props.isProfileFlow ? 'default' : 'pointer')};
`;

const InputPhoneWithDropdown = (props) => {
    const [isFocused, setIsFocused] = useState(false);
    const [iso2PhoneNonStrict, setIso2PhoneNonStrict] = useState(props.iso2);
    const changeHandler = (value, data, selectedCountry) => {
        if (!props.isPhoneTypeStrict && selectedCountry?.iso2 && props.isNonEditableCountry) {
            setIso2PhoneNonStrict(selectedCountry.iso2);
        } else {
            props.onChangeHandler?.(value, data);
        }
    };
    const showCountryModal = () => {
        if (props.formName === LOGIN_REGISTRATION_FORM_NAME) {
            amplitude.getInstance().logEvent(COUNTRY_CODE_CLICKED, {
                [PHONE_COUNTRY]: props.countryName,
                [FLOW]: props.flowName,
            });
        }
        if (!props.isNonEditableCountry) {
            props.showCountryModal();
        } else {
            if (props.isProfileFlow) {
                props.popupRef.current?.open(<ChangeCountryCodePopup popupRef={props.popupRef} />);
            }
        }
    };

    return (
        <NewInputPhone
            onChangeHandler={changeHandler}
            onBlurHandler={props.onBlurHandler}
            userInputRef={props.userInputRef}
            field={props.field}
            submitRef={props.submitRef}
            submitNumberOnLogin={props.submitNumberOnLogin}
            defaultCountry={props.iso2}
            formName={props.formName}
            submitByEnter={props.submitByEnter}
            onFocus={props.onFocus}
            focus={props.focus}
            onChange={props.onChange}
            onKeyDown={props.onKeyDown}
            onBlur={props.onBlur}
            isFilled={true}
            isFocused={isFocused}
            setIsFocused={setIsFocused}
            isNewInput
            iso2={props.iso2}
            changeFormFieldValue={props.changeFormFieldValue}
            prefix={props.prefix}
            getUserInputWithoutPrefix={props.getUserInputWithoutPrefix}
            userInputWithoutPrefix={props.userInputWithoutPrefix}
            isPhoneTypeStrict={props.isPhoneTypeStrict || true}
            hintButtonClick={props.hintButtonClick}
            isLoginInputError={props.isLoginInputError}
            setLoginInputError={props.setLoginInputError}
            shouldValidateUserNumberFormat={props.shouldValidateUserNumberFormat}
            validateNumberFormat={props.validateNumberFormat}
            setFocusOnLogin={props.setFocusOnLogin}
            leftInputComponent={
                <FlagIconDropdown onClick={showCountryModal} isNonEditableCountry={props.isNonEditableCountry}>
                    <FlagIcon name={props.isPhoneTypeStrict || !props.isNonEditableCountry ? props.iso2 : iso2PhoneNonStrict} />
                    {(!props.isNonEditableCountry || props.isProfileFlow) && <Icon name="chevron-down" leftIndent="4px" />}
                </FlagIconDropdown>
            }
        />
    );
};
InputPhoneWithDropdown.propTypes = {
    isPhoneTypeStrict: PropTypes.bool,
    isNonEditableCountry: PropTypes.bool,
};
export default InputPhoneWithDropdown;
